import {createContext} from "react";

export const PickingMissionModelContext = createContext({
    data: null,
    editableModel: null,
    isEdit: false,
    isModel: false,
    isModelAuto: false,
    isMobile: false,
    setIsModelAuto: (isAuto) => {},
    setIsModel: (isModel) => {},
    init: () => {}
})